<template>
    <div
        class="dual-ipads"
        :class="{
            'dual-ipads--reverse': reverse,
            'dual-ipads--overlap': overlap,
            'dual-ipads--overlap-shift': overlapShift,
            'dual-ipads--overlap-reverse': overlapReverse,
            'dual-ipads--no-text': noText,
        }"
    >
        <div class="container">
            <div class="dual-ipads__container">
                <div class="dual-ipads__column">
                    <div class="ipad" :class="{ 'ipad--portrait': !bothLandscape }">
                        <slot name="left" />
                    </div>
                </div>

                <div class="dual-ipads__column">
                    <div class="ipad">
                        <slot name="right" />
                    </div>
                </div>

                <div class="dual-ipads__content" v-fade.in.out>
                    <h3 v-if="title" class="dual-ipads__title text-heading text-heading--xs" v-html="title"></h3>
                    <p v-if="body" class="dual-ipads__body text-body" v-html="body"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        reverse: Boolean, // Reverse the usual layout
        overlap: Boolean, // Use two landscape iPads and overlap slightly
        overlapReverse: Boolean, // Standard overlap with left on top
        overlapShift: Boolean, // Use two landscape iPads and overlap slightly
        noText: Boolean, // shortens gap below if no textfor block
        title: String,
        body: String,
    },

    computed: {
        bothLandscape() {
            return this.overlap || this.overlapShift || this.overlapReverse || this.over ? true : false;
        },
    },
};
</script>
